"use strict";

define('uikit/modules/pagination',['require','exports','module','underscore','marionette','../helper/browser','../collections/container','../mixins/component.mixin','../channel','./menu','../templates'],function (require, exports, module) {
  var _ = require('underscore');
  var Mn = require('marionette');
  var browser = require('../helper/browser');
  var ContainerView = require('../collections/container');
  var ComponentMixin = require('../mixins/component.mixin');
  var channel = require('../channel');
  var Menu = require('./menu');
  var Templates = require('../templates');
  var PaginationItem = Menu.Item.extend({
    tagName: 'a',
    template: Templates.UIKit['pagination.item']
  });
  var Pagination = Menu.extend({
    template: false,
    options: _.extend({}, Menu.prototype.options, {
      totalPages: 20,
      currentPage: 1,
      pageShowAmount: 5,
      alwaysShowEnds: false,
      ariaLabel: null,
      ariaLabelledby: null,
      ariaDescribedby: null,
      pagination: true
    }),
    events: {
      'keydown > .item': 'handleMenuItemKeydown'
    },
    update: _.extend({}, Menu.prototype.update, {
      totalPages: false,
      currentPage: false,
      pageShowAmount: false,
      alwaysShowEnds: false
    }),
    initialize: function initialize(options) {
      ContainerView.prototype.initialize.apply(this, arguments);
      this.on('first:render', this.updatePaginationItems);
      this.listenTo(this.vent, "change:totalPages change:currentPage change:pageShowAmount change:alwaysShowEnds", this.updatePaginationItems);
    },
    getMenuItemViews: function getMenuItemViews() {
      return _.map(this._views, function (menuItemViewConfig) {
        return menuItemViewConfig.view;
      });
    },
    getMenuItemDOMElements: function getMenuItemDOMElements() {
      return _.map(this.getMenuItemViews(), function (menuItemView) {
        return menuItemView.el;
      });
    },
    getMenuItemViewByIndex: function getMenuItemViewByIndex(itemIndex) {
      return this.getMenuItemViews()[itemIndex];
    },
    handleMenuItemKeydown: function handleMenuItemKeydown(ev) {
      var self = this;
      var menuItemViews = this.getMenuItemViews();
      var menuItemDOMElements = this.getMenuItemDOMElements();
      var currentIndex = menuItemDOMElements.indexOf(ev.target);
      var currentItemView = menuItemViews[currentIndex];
      var isEllipsisNext = function isEllipsisNext(nextItemIndex) {
        var nextItem = self.getMenuItemViewByIndex(nextItemIndex);
        return nextItem && nextItem.text === '...';
      };
      switch (ev.keyCode) {
        case 13:
        case 32:
          ev.preventDefault();
          ev.stopImmediatePropagation();
          if (!currentItemView.disabled) {
            currentItemView.triggerMethod('press', currentItemView, currentItemView.model);
          }
          break;
        case 35:
          ev.preventDefault();
          this.getMenuItemViewByIndex(menuItemViews.length - 1).$el.focus();
          break;
        case 36:
          ev.preventDefault();
          this.getMenuItemViewByIndex(0).$el.focus();
          break;
        case 37:
          var decrement = isEllipsisNext(currentIndex - 1) ? 2 : 1;
          var itemIndex = currentIndex > 0 ? currentIndex - decrement : menuItemViews.length - 1;
          this.getMenuItemViewByIndex(itemIndex).$el.focus();
          break;
        case 39:
          var increment = isEllipsisNext(currentIndex + 1) ? 2 : 1;
          var itemIndex = currentIndex < menuItemViews.length - 1 ? currentIndex + increment : 0;
          this.getMenuItemViewByIndex(itemIndex).$el.focus();
          break;
        default:
          break;
      }
      return;
    },
    _getCurrentPageRange: function _getCurrentPageRange() {
      var current = this.getOption('currentPage'),
        total = this.getOption('totalPages'),
        showAmt = this.getOption('pageShowAmount'),
        range = [],
        start = current - Math.floor(showAmt / 2);
      if (start + (showAmt - 1) > total) {
        start -= start + (showAmt - 1) - total;
      }
      if (start < 1) {
        start = 1;
      }
      var i = start;
      while (i <= total && i - start < showAmt) {
        range.push(i);
        i++;
      }
      return range;
    },
    appendView: function appendView(view, options) {
      this.$el.append(view.$el);
    },
    updateAttributes: function updateAttributes() {
      if (this.getBoolOption('ariaLabel')) {
        this.updateElementAttributes({
          'aria-label': this.getOption('ariaLabel')
        });
      }
      if (this.getBoolOption('ariaLabelledby')) {
        this.updateElementAttributes({
          'aria-labelledby': this.getOption('ariaLabelledby')
        });
      }
      if (this.getBoolOption('ariaDescribedby')) {
        this.updateElementAttributes({
          'aria-describedby': this.getOption('ariaDescribedby')
        });
      }
      this.updateElementAttributes({
        'role': 'navigation'
      });
      Menu.prototype.updateAttributes.apply(this, arguments);
    },
    onChildviewRender: function onChildviewRender(view) {
      if (browser.isIE() == '9') {
        view.$el.css({
          'padding-left': '0px',
          'padding-right': '0px'
        });
      }
    },
    onChildviewPress: function onChildviewPress(view) {
      if (view == this._leftArrow && this.currentPage > 1) {
        this.currentPage--;
      } else if (view == this._rightArrow && this.currentPage < this.totalPages) {
        this.currentPage++;
      } else if (view.text) {
        this.currentPage = Number(view.text);
      }
    },
    _setDisabled: function _setDisabled(item, isDisabled) {
      item.removeElementAttribute('aria-disabled');
      item.disabled = isDisabled;
      if (isDisabled) {
        item.updateElementAttributes({
          'aria-disabled': true
        });
      }
      return item;
    },
    _configureEllipsisItem: function _configureEllipsisItem(ellipsisItem) {
      ellipsisItem.text = "...";
      ellipsisItem.removeElementAttribute('tabindex');
      ellipsisItem.updateElementAttributes({
        'aria-hidden': true
      });
      this._setDisabled(ellipsisItem, true);
    },
    _createNewItem: function _createNewItem() {
      var newItem = new PaginationItem();
      newItem.options.role = null;
      this.add(newItem, {
        destroyOnRemove: true
      });
      return newItem;
    },
    _getNextMenuItem: function _getNextMenuItem() {
      var item = this.currentItems.length ? this.currentItems.shift().view : this._createNewItem();
      item.icon = null;
      item.text = '';
      item.active = false;
      this._setDisabled(item, false).removeElementAttribute('aria-current').removeElementAttribute('aria-hidden');
      return item;
    },
    configureLeftArrow: function configureLeftArrow() {
      var current = this.getOption('currentPage');
      var total = this.getOption('totalPages');
      var numberOfPagesShown = this.model.get('size');
      this._leftArrow = this._getNextMenuItem();
      this._leftArrow.icon = "left arrow";
      this._leftArrow.updateElementAttributes({
        'aria-label': 'previous ' + numberOfPagesShown + ' pages'
      });
      if (current <= 1 || total === 0) {
        this._setDisabled(this._leftArrow, true);
      }
      return this;
    },
    configureRightArrow: function configureRightArrow() {
      var current = this.getOption('currentPage');
      var total = this.getOption('totalPages');
      var numberOfPagesShown = this.model.get('size');
      this._rightArrow = this._getNextMenuItem();
      this._rightArrow.icon = "right arrow";
      this._rightArrow.updateElementAttributes({
        'aria-label': 'next ' + numberOfPagesShown + ' pages'
      });
      if (current >= total) {
        this._setDisabled(this._rightArrow, true);
      }
      return this;
    },
    configureFirstPageItem: function configureFirstPageItem() {
      var total = this.getOption('totalPages'),
        showEnds = this.getOption('alwaysShowEnds'),
        pageRange = this._getCurrentPageRange();
      if (total > 0 && pageRange[0] !== 1 && showEnds) {
        this._getNextMenuItem().text = "1";
        if (pageRange[0] !== 2) {
          this._configureEllipsisItem(this._getNextMenuItem());
        }
      }
      return this;
    },
    configureLastPageItem: function configureLastPageItem() {
      var total = this.getOption('totalPages'),
        showEnds = this.getOption('alwaysShowEnds'),
        pageRange = this._getCurrentPageRange();
      if (total > 0 && pageRange[pageRange.length - 1] !== total && showEnds) {
        if (pageRange[pageRange.length - 1] !== total - 1) {
          this._configureEllipsisItem(this._getNextMenuItem());
        }
        this._getNextMenuItem().text = total;
      }
      return this;
    },
    configureRangeItems: function configureRangeItems() {
      var current = this.getOption('currentPage');
      var pageRange = this._getCurrentPageRange();
      for (var i = 0, len = pageRange.length, item; i < len; i++) {
        var nextItem = this._getNextMenuItem();
        nextItem.removeElementAttribute('aria-label');
        nextItem.text = pageRange[i];
        if (current === pageRange[i]) {
          nextItem.active = true;
          nextItem.updateElementAttributes({
            'aria-current': 'page'
          });
        }
      }
      return this;
    },
    removeOldItems: function removeOldItems() {
      while (this.currentItems.length) {
        this.removeView(this.currentItems.pop().view);
      }
    },
    updatePaginationItems: function updatePaginationItems() {
      this.currentItems = this._views.slice();
      this.configureLeftArrow().configureFirstPageItem().configureRangeItems().configureLastPageItem().configureRightArrow().removeOldItems();
    }
  });
  channel.reply('pagination', function () {
    return Pagination;
  });
  module.exports = Pagination;
});

